import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './_admin';

// Code splitting: Lazy load UserDetailPage to reduce initial bundle size
const UserDetailPage = lazy(() => import('@/pages/admin/UserDetailPage'));

/**
 * Admin user detail route - /admin/users/:userId
 * Shows detailed information for a specific user
 */
export const adminUserDetailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'users/$userId',
  component: UserDetailPage,
});

// Backward compatibility
export const Route = adminUserDetailRoute;
